"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
var _typeof2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
var _LotteryTablePane = _interopRequireDefault(require("./LotteryTablePane.vue"));
var _LotteryConfigPane = _interopRequireDefault(require("./LotteryConfigPane.vue"));
var _LotteryRecordPane = _interopRequireDefault(require("./LotteryRecordPane.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Lottery',
  components: {
    LotteryTablePane: _LotteryTablePane.default,
    LotteryConfigPane: _LotteryConfigPane.default,
    LotteryRecordPane: _LotteryRecordPane.default
  },
  data: function data() {
    return {
      activeName: 'lottery_table',
      tabIndex: 0,
      // 配置Tab数组
      configTabs: [],
      // 抽奖记录Tab数组
      recordTabs: [],
      // 通用数据缓存 - 所有配置tab共享
      sharedData: {
        // 活动详情缓存
        activityDetails: {},
        // 图片前缀
        imagePrefix: '',
        // 优惠券列表
        bonusList: [],
        // 菜品分类树
        categoryTree: [],
        // 门店树
        storeTree: []
      }
    };
  },
  methods: {
    handleToLotteryConfig: function handleToLotteryConfig(payload) {
      // payload可能是id（旧逻辑）、null（添加新活动）或者{ id, title }对象（新逻辑）
      var id = null;
      var title = '';
      if (payload === null || payload === undefined) {
        // 添加新活动，id保持为null
      } else if ((0, _typeof2.default)(payload) === 'object' && payload !== null) {
        // 编辑活动，传递的是对象
        id = payload.id;
        title = payload.title || '';
      } else {
        // 兼容旧逻辑：payload直接是id
        id = payload;
      }
      if (!id) {
        // 添加新活动
        this.openAddConfig();
      } else {
        // 编辑活动
        this.openEditConfig(id, title);
      }
    },
    openAddConfig: function openAddConfig() {
      var name = "config-add-".concat(++this.tabIndex);
      this.configTabs.push({
        name: name,
        title: '添加抽奖活动',
        id: null,
        type: 'add'
      });
      this.activeName = name;
    },
    openEditConfig: function openEditConfig(id, title) {
      // 检查是否已存在同一个活动ID的编辑标签页
      var existingTab = this.configTabs.find(function (t) {
        return t.id === id && t.type === 'edit';
      });
      if (existingTab) {
        // 如果已存在，直接切换到该标签页
        this.activeName = existingTab.name;
        return;
      }
      // 否则创建新标签页
      var name = "config-edit-".concat(id, "-").concat(++this.tabIndex);
      this.configTabs.push({
        name: name,
        title: title ? "\u7F16\u8F91\u6D3B\u52A8-".concat(title) : '编辑抽奖活动',
        id: id,
        type: 'edit'
      });
      this.activeName = name;
    },
    handleConfigSuccess: function handleConfigSuccess(tabName) {
      this.closeTab(tabName, true);
    },
    handleConfigCancel: function handleConfigCancel(tabName) {
      this.closeTab(tabName, false);
    },
    handleToLotteryRecord: function handleToLotteryRecord(row) {
      var id = row.id,
        title = row.title;
      // 检查是否已存在同一个活动ID的标签页
      var existingTab = this.recordTabs.find(function (t) {
        return t.lotteryId === id;
      });
      if (existingTab) {
        // 如果已存在，直接切换到该标签页
        this.activeName = existingTab.name;
        return;
      }
      // 否则创建新标签页
      var name = "record-".concat(++this.tabIndex);
      this.recordTabs.push({
        name: name,
        title: "\u62BD\u5956\u8BB0\u5F55 - ".concat(title),
        lotteryId: id,
        lotteryTitle: title
      });
      this.activeName = name;
    },
    closeTab: function closeTab(targetName, refreshed) {
      var active = this.activeName;

      // 关闭配置Tab
      var configIdx = this.configTabs.findIndex(function (t) {
        return t.name === targetName;
      });
      if (configIdx > -1) {
        var closingTab = this.configTabs[configIdx];

        // 清除该活动的缓存（无论是否刷新，关闭tab都要清除）
        if (closingTab.id) {
          console.log('关闭tab，清除活动缓存，id:', closingTab.id);
          if (this.sharedData && this.sharedData.activityDetails) {
            delete this.sharedData.activityDetails[closingTab.id];
          }
        }
        if (active === targetName) {
          var next = this.configTabs[configIdx + 1] || this.configTabs[configIdx - 1];
          active = next ? next.name : 'lottery_table';
        }
        this.configTabs = this.configTabs.filter(function (t) {
          return t.name !== targetName;
        });
      }
      // 关闭记录Tab
      else {
        var recordIdx = this.recordTabs.findIndex(function (t) {
          return t.name === targetName;
        });
        if (recordIdx > -1) {
          if (active === targetName) {
            var _next = this.recordTabs[recordIdx + 1] || this.recordTabs[recordIdx - 1];
            active = _next ? _next.name : 'lottery_table';
          }
          this.recordTabs = this.recordTabs.filter(function (t) {
            return t.name !== targetName;
          });
        }
      }
      this.activeName = active;

      // 刷新列表
      if (refreshed) {
        this.$refs.lottery_table.fetchData();
      }
    },
    removeTab: function removeTab(targetName) {
      this.closeTab(targetName, false);
    }
  }
};